/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp, h } from 'vue';
import { createRouter, createWebHistory } from "vue-router";
import PrimeVue from 'primevue/config';
import VehicleSearch from './vue/vehicleSearch.vue';
import ToastService from 'primevue/toastservice';
import  PrimevueLocale  from './vue/primevueLocale';

const vehicleSearchAppSelector = "#vehicleSearch";
const vehicleSearchElement = document.querySelector(vehicleSearchAppSelector);
if (vehicleSearchElement) {
    const nodeId = parseInt(vehicleSearchElement.dataset.nodeId);
    const isUserLoggedIn = vehicleSearchElement.dataset.isUserLoggedIn == "True";
    const hideFilter = vehicleSearchElement.dataset.hideFilter == "True";
    const preFilter = JSON.parse(vehicleSearchElement.dataset.preFilter);
    const favoritesPageUrl = vehicleSearchElement.dataset.favoritesPageUrl;
    const dictionary = JSON.parse(vehicleSearchElement.dataset.dictionary);

    const router = createRouter({
        history: createWebHistory(),
        routes: [{ path: window.location.pathname, component: VehicleSearch }]
    });

    const seedData = {
        nodeId:nodeId,
        isUserLoggedIn:isUserLoggedIn,
        hideFilter:hideFilter,
        preFilter:preFilter,
        favoritesPageUrl:favoritesPageUrl,
        dictionary:dictionary
    };

    const vehicleSearch = createApp({
        data() { return seedData },
        render: () => h(VehicleSearch)
    }, seedData);

    vehicleSearch.use(router);
    vehicleSearch.use(ToastService);
    vehicleSearch.use(PrimeVue,{
        locale:PrimevueLocale.locale
    });

    router.isReady().then(() => vehicleSearch.mount(vehicleSearchAppSelector));
}